<template>
  <div class="maincontainer" v-infinite-scroll="loadMore"
    infinite-scroll-distance="10">
     <div class="row">
        <div class="col offset-s10 s1 label" style="padding-bottom: 20px;">
          <a class="waves-effect waves-light btn-large green"  style="border-radius: 8px; line-height: 2.5; height: 35px;" v-on:click="edit = false; " :href="'/inspections/'+fromts+'/'+tots+'.xlsx'" :download="$t('inspections.file_title') + fromTsFormatted + ' - ' + toTsFormatted  +'.xlsx'">{{$t('interventions.xls')}}</a>
        </div>
    </div>
    <div>
      <table>
        <thead style="position: sticky; top: 100px;">
          <tr>
              <th style="width: 1%;" v-if="role == 'ddd_admin' || (role == 'ddd_worker')"></th>
              <th style="width: 20%;">
                <p v-on:click="set_order('date')"  class="cursor-pointer">
                  <span>{{$t('inspections.date')}}</span>
                  <i class="material-icons dp6" v-if="orderby == 'date' && order == 'desc'">arrow_drop_down</i>
                  <i class="material-icons dp6" v-if="orderby == 'date' && order == 'asc'">arrow_drop_up</i>
                </p>
                <select v-model="rangeSelected">
                  <option value="currentMonth">{{$t('calendar.current_month')}}</option>
                  <option value="prevMonth">{{$t('calendar.prev_month')}}</option>
                  <option value="lastThreeMonths">{{$t('calendar.last_three_months')}}</option>
                  <option value="currentYear">{{$t('calendar.current_year')}}</option>
                    <option value="prevYear">{{$t('calendar.previous_year')}}</option>
                    <option value="other">{{$t('calendar.other_range')}}</option>
                </select>
                <div class="row" v-if="rangeSelected == 'other'">
                  <div class="col s6 input-field" style="padding-left: 0px;padding-right: 5px; min-width: 13ch;">
                    <input type="date" v-model="fromSelected"/>
                    <button class="waves-effect waves-light btn-large gray" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px; padding-right: 0px; width: 100%" v-on:click="cancelChanges()">{{$t('calendar.cancel')}}</button>
                  </div>
                  <div class="col s6 input-field" style="padding-right: 5px;padding-left: 5px; min-width: 13ch;">
                    <input type="date" v-model="toSelected"/>
                    <button class="waves-effect waves-light btn-large green" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px; padding-right: 0px; width: 100%" v-on:click="applyChanges()">{{$t('calendar.apply')}}</button>
                  </div>
                </div>
              </th>
              <th>
                <p v-on:click="set_order('place_name')" class="cursor-pointer">
                  <span>{{$t('inspections.customer_place')}}</span>
                  <i class="material-icons dp6" v-if="orderby == 'place_name' && order == 'desc'">arrow_drop_down</i>
                  <i class="material-icons dp6" v-if="orderby == 'place_name' && order == 'asc'">arrow_drop_up</i>
                </p>
                <div class="input-field"><input v-model="customersearch"/></div>
              </th>
              <th >
                <p v-on:click="set_order('notices')" class="cursor-pointer">
                  <span>{{$t('inspections.notices')}}</span>
                  <i class="material-icons dp6" v-if="orderby == 'tags' && order == 'desc'">arrow_drop_down</i> 
                  <i class="material-icons dp6" v-if="orderby == 'tags' && order == 'asc'">arrow_drop_up</i>
                  <div class="input-field"><input v-model="notionssearch"/></div>
                </p>
              </th>
              <th>
                <p v-on:click="set_order('fraction')" class="cursor-pointer">
                  <span>{{$t('inspections.result')}}</span>
                  <i class="material-icons dp6" v-if="orderby == 'fraction' && order == 'desc'">arrow_drop_down</i> 
                  <i class="material-icons dp6" v-if="orderby == 'fraction' && order == 'asc'">arrow_drop_up</i>
                </p>
              </th>
              <th style="width: 20%;" class="cursor-pointer">
                <p v-on:click="set_order('worker_name')" class="cursor-pointer">
                  <span>{{$t('inspections.worker')}}</span>
                  <i class="material-icons dp6" v-if="orderby == 'worker_name' && order == 'desc'">arrow_drop_down</i> 
                  <i class="material-icons dp6" v-if="orderby == 'worker_name' && order == 'asc'">arrow_drop_up</i>
                </p>
                <selector  v-model="selected_workers" :items="workerItems" identifier="workerselector" v-if="loaded"></selector>
              </th>
              <th></th>
              <th></th>
              <th></th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr v-for="(inspection, index) in items" :key="inspection.id">
            <td v-if="role == 'ddd_admin' || (role == 'ddd_worker')">
              <div style="display: inline-flex; align-items: center; gap: 8px;">
                <colorselector :color="inspection.color" v-on:colorSelected="changeColor(inspection, $event)" />
                <input 
                  type="text"
                  v-model="inspection.misc_info" 
                  @blur="updateMiscInfo(inspection)" 
                  style="flex: 1; min-width: 150px; border-bottom: none;"
                />
              </div>
            </td>
            <td>{{inspection.date | formatDate}}</td>
            <td>{{inspection.customer_name}} / {{inspection.place_name}}</td>
            <td style="font-size: 12px;">
              <template v-for="notice, i in inspection.notices">
                {{notice}}<br v-if="i < (inspection.notices.length - 1)" />
              </template>
              <template v-if="inspection.change_suggestions.length > 0 && (role == 'ddd_admin' || role == 'ddd_worker')">
                      <br/>{{$t('inspections.need_change')}}: <template v-for="(change_suggestion, index) in inspection.change_suggestions">
                        <template v-if="index > 0">, </template>{{change_suggestion.number}}
                      </template>
                </template>
            </td>
            <td style="white-space: nowrap;">{{inspection.total ? inspection.total : 0}} / {{inspection.out_of ? inspection.out_of : 0}}</td>
            <td>{{inspection.worker_name}}</td>
            <td>
              <a :href="'#/customers/'+inspection.customer_id+'/places/'+inspection.place_id+'/inspections/'+inspection.id" :title="$t('inspections.inspection')"> <i class="material-icons dp6">equalizer</i> </a>
            </td>
            <td>
              <a :href="'#/customers/'+inspection.customer_id+'/places/'+inspection.place_id+'/inspections/'+inspection.id+'/summary'" :title="$t('inspections.summary')"> <i class="material-icons dp6">featured_play_list</i> </a>
            </td>
            <td>
               <a :href="'#/customers/'+inspection.customer_id+'/places/'+inspection.place_id+'/inspections/'+inspection.id + '/recommendations'" :title="$t('inspections.recommendations')"> <i class="material-icons dp6">check_box</i> </a>
            </td>
          </tr>
        </tbody>
        <preloader v-if="loaded == false" n="7"/>
      </table>
    </div>
    <template v-if="items.length == 0 && loaded">
      <p style="font-size: 12px; text-align: center;">{{$t('inspections.no_inspections')}}</p>
    </template>
  </div>
</template>

<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import moment from 'moment';
export default {
  data: function () {
    return {
      order: 'desc',
      orderby: 'date',
      places: [],
      loaded: false,
      selected_workers: [],
      workerItems: [],
      rangeSelected: "currentMonth",
      lastRange: "currentMonth",
      from: moment().startOf("month"),
      to: moment().endOf("month"),
      fromts: 0,
      tots: 0,
      fromTsFormatted: '',
      toTsFormatted: '',
      fromSelected: moment().startOf("month").format("YYYY-MM-DD"),
      toSelected: moment().endOf("month").format("YYYY-MM-DD"),
      customersearch: "",
      notionssearch: "",
      colors: [ "white", "red", "green", "orange", "blue", "yellow", "violet", "gray", "black" ],
      busy: false,
      noMoreData: false,
      items: [],
      itemsperpage: 50,
      listedItems: [],
      index: 0
    }
  },
  props: {role: String},
  async created() {
    var that = this;
    this.fetch_items(moment(that.from), moment(that.to));
    var response = await axios.get('/inspections/last.json')
    if(response.data != null){
        var last_time = moment(response.data * 1000);
        if(last_time.isBetween(moment().startOf("month"), moment().endOf("month"))) that.rangeSelected = "currentMonth";
        else if(last_time.isBetween(moment().subtract(1,'months').startOf("month"), moment().subtract(1,'months').endOf("month"))) that.rangeSelected = "prevMonth";
        else if(last_time.isBetween(moment().subtract(3,'months').startOf("month"), moment().endOf("month"))) that.rangeSelected = "lastThreeMonths";
        else if(last_time.isBetween(moment().startOf("year"), moment().endOf("year"))) that.rangeSelected = "currentYear";
        else if(last_time.isBetween(moment().subtract(1,'years').startOf("year"), moment().subtract(1,'years').endOf("year")))
          that.rangeSelected = "prevYear";
        else{
          that.from = last_time.clone().startOf("month").format("YYYY-MM-DD")
          that.fromSelected = last_time.clone().startOf("month").format("YYYY-MM-DD")
          that.to = last_time.clone().endOf("month").format("YYYY-MM-DD")
          that.toSelected = last_time.clone().endOf("month").format("YYYY-MM-DD")
          that.rangeSelected = "other";
        }
    }
  },
  watch: {
    rangeSelected: function (val) {
      if(val == "currentMonth"){
        this.lastRange = val;
        this.from = moment().startOf("month").format("YYYY-MM-DD")
        this.fromSelected = moment().startOf("month").format("YYYY-MM-DD")
        this.to = moment().endOf("month").format("YYYY-MM-DD")
        this.toSelected = moment().endOf("month").format("YYYY-MM-DD")
      }else if(val == "prevMonth"){
        this.lastRange = val;
        this.from = moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD")
        this.fromSelected = moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD")
        this.to = moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")
        this.toSelected = moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")
      }else if(val == "lastThreeMonths"){
        this.lastRange = val;
        this.from = moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD")
        this.fromSelected = moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD")
        this.to = moment().endOf("month").format("YYYY-MM-DD")
        this.toSelected = moment().endOf("month").format("YYYY-MM-DD")
      }else if(val == "currentYear"){
        this.lastRange = val;
        this.from = moment().startOf("year").format("YYYY-MM-DD")
        this.fromSelected = moment().startOf("year").format("YYYY-MM-DD")
        this.to = moment().endOf("year").format("YYYY-MM-DD")
        this.toSelected = moment().endOf("year").format("YYYY-MM-DD")
      }else if(val == "prevYear"){
        this.lastRange = val;
        this.from = moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD")
        this.fromSelected = moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD")
        this.to = moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")
        this.toSelected = moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")
      }
      this.loaded = false;
      this.fetch_items(moment(this.from), moment(this.to));
    },
    customersearch: function (val) {
      this.reset_list();
    },
    notionssearch: function (val) {
      this.reset_list();
    },
    workerItems: function (val) {
      this.reset_list();
    },
    selected_workers: function (val) {
      this.reset_list();
    }
  },
  methods: {
    updateMiscInfo(inspection) {
      axios.put(`/inspections/${inspection.id}.json`, { misc_info: inspection.misc_info })
        .then(response => {
          console.log("Misc info updated successfully");
        })
        .catch(error => {
          console.error("Error updating misc info:", error);
        });
    },
    fetch_items: function(a, b){
      this.loaded = false;
      this.fromts = a.unix();
      this.tots = b.unix()
      this.fromTsFormatted = a.format('D.M.YYYY');
      this.toTsFormatted = b.format('D.M.YYYY');
      axios.get('/inspections/'+a.unix()+'/'+b.endOf('day').unix()+'.json').then(response => {
        this.places = response.data;
        for(var i in this.places){
          var item = this.places[i];
          item.fraction = item.total / item.out_of
          if(item.worker_name != null){
            this.workerItems.push({value: item.worker_name, name: item.worker_name});
          } 
        }
        this.workerItems = _.uniqBy(this.workerItems, itm => {
          return itm.value;
        });
        this.loaded = true;
        this.noMoreData = false;
        this.busy = false;
        this.items = [];
        this.loadMore();
      })
    },
    reset_list: function(){
      this.index = 0;
      this.noMoreData = false;
      this.items = this.listItems.slice(0, this.index + this.itemsperpage);
      this.index += this.itemsperpage;
    },
    collapse : function(customer){
      inspection.collapsed = !(inspection.collapsed);
      this.$forceUpdate();
    },
    set_order: function(order){
      if(this.orderby == order){
        if(this.order == 'desc'){
          this.order = 'asc'
        }else if(this.order == 'asc'){
          this.order = 'desc'
        }
        
      }else{
        this.orderby = order;
      }
      this.reset_list();
    },
    applyChanges: function(){
      this.from = this.fromSelected;
      this.to = this.toSelected;
      this.fetch_items(moment(this.from), moment(this.to))
    },
    changeColor: function(inter, color){
        axios.put("/inspections/"+inter.id+".json", {color: color}).then(response => {
          // Successfully updated on server
        }).catch(error => {
          // Handle error
        });
        inter.color = color;
    },
    loadMore() {
      if (this.busy || this.noMoreData) return;
      this.busy = true;
      const nextChunk = this.listItems.slice(this.index, this.index + this.itemsperpage);
      if (nextChunk.length > 0) {
        this.items = [...this.items, ...nextChunk];
        this.index += this.itemsperpage;
      } else {
        this.noMoreData = true; 
      }
      this.busy = false;
    }
},
computed: {
    listItems() {
      var that = this;
      return _.filter(
        _.orderBy(that.places, that.orderby, that.order),
        function(item){
          return (item.customer_name.toUpperCase().indexOf(that.customersearch.toUpperCase()) >= 0 || item.place_name.toUpperCase().indexOf(that.customersearch.toUpperCase()) >= 0)  &&
          moment(item.date).isBetween(that.from, that.to, 'day', '[]') &&
          (that.selected_workers.indexOf(item.worker_name) >= 0 || that.selected_workers.length == 0) &&
          (_.filter(item.notices, function(subitem){
                      return subitem.indexOf(that.notionssearch) >= 0
            }).length > 0 || (item.notices.length == 0 && that.notionssearch.length == 0))  ;
        }
      );
    },
},
mixins: [Vue2Filters.mixin],
}
</script>

<style scoped>
.login_button{
  color: red;
}
.maincontainer{
  padding-top: 33px;
  margin: 33px;
}
p{
  margin: 0em;
}
thead{
  background-color: #DADADA;
}
thead th{
  font-weight: 300;
  padding-top: 5px;
  padding-bottom: 5px;
}
thead .input-field{
  margin-top: unset;
  margin-bottom: unset;
}
select {
  display: block;
  padding-top: 0px;
  padding-bottom: 0 0 0 0;
  height: 35px;
  border-radius: 4px !important;
  border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
}
th {
  vertical-align: baseline;
}
.maincontainer td {
    padding-left: 10px;
    padding-right: 10px;
}
</style>
